import { render } from "./ProjectCode.vue?vue&type=template&id=0d263283&ts=true"
import script from "./ProjectCode.vue?vue&type=script&lang=ts"
export * from "./ProjectCode.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__